/* ==========================================================================
   Product Recommendations
   - Fetches recommended products via the Section Rendering API
     (/recommendations/products with intent=related), so Search & Discovery
     "Related products" rules apply.
   - Tab switching between Recommended / Recently viewed (the Recently viewed
     panel is rendered server-side from a merchant-picked collection).
   ========================================================================== */
(function () {
  var SECTION_SELECTOR = '.oddit-section-product-recommendations';
  var GRID_SELECTOR = '[data-recommendations-grid]';

  function revealCards(grid) {
    var reveals = grid.querySelectorAll('.oddit-reveal');
    if (reveals.length === 0) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        for (var i = 0; i < reveals.length; i++) {
          reveals[i].classList.add('is-visible');
        }
      });
    });
  }

  function fetchRecommendations(section) {
    var productId = section.getAttribute('data-product-id');
    var sectionHandle = section.getAttribute('data-section-handle');
    var intent = section.getAttribute('data-recommendations-intent') || 'related';
    var grid = section.querySelector(GRID_SELECTOR);

    if (!productId || !sectionHandle || !grid) return;

    // Always request Shopify's max (10) so the section's tag-based filter has
    // buffer to drop utility products without leaving gaps in the rendered grid.
    var url =
      '/recommendations/products?section_id=' + encodeURIComponent(sectionHandle) +
      '&product_id=' + encodeURIComponent(productId) +
      '&intent=' + encodeURIComponent(intent) +
      '&limit=10';

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fetchedGrid = doc.querySelector(GRID_SELECTOR);
        var hasCards = fetchedGrid && fetchedGrid.children.length > 0;

        if (hasCards) {
          grid.innerHTML = fetchedGrid.innerHTML;
          revealCards(grid);
        } else {
          // No related products available — hide the section to avoid empty heading.
          section.hidden = true;
        }
      })
      .catch(function (err) {
        if (window.console && console.warn) {
          console.warn('[oddit-product-recommendations] fetch failed', err);
        }
        section.hidden = true;
      });
  }

  function initSection(section) {
    var tabs = section.querySelectorAll('[role="tab"]');
    var panels = section.querySelectorAll('[role="tabpanel"]');

    fetchRecommendations(section);

    if (tabs.length === 0 || panels.length === 0) return;

    function activateTab(selectedTab) {
      for (var i = 0; i < tabs.length; i++) {
        var tab = tabs[i];
        var panelId = tab.getAttribute('aria-controls');
        var panel = section.querySelector('#' + panelId);

        if (tab === selectedTab) {
          tab.setAttribute('aria-selected', 'true');
          tab.classList.add('oddit-section-product-recommendations__tab--active');
          if (panel) {
            panel.removeAttribute('hidden');
            panel.classList.add('oddit-section-product-recommendations__panel--active');
          }
        } else {
          tab.setAttribute('aria-selected', 'false');
          tab.classList.remove('oddit-section-product-recommendations__tab--active');
          if (panel) {
            panel.setAttribute('hidden', '');
            panel.classList.remove('oddit-section-product-recommendations__panel--active');
          }
        }
      }

      // Re-trigger reveal animations for newly visible panel
      var activePanel = section.querySelector('.oddit-section-product-recommendations__panel--active');
      if (activePanel) {
        var reveals = activePanel.querySelectorAll('.oddit-reveal');
        for (var j = 0; j < reveals.length; j++) {
          reveals[j].classList.remove('is-visible');
        }
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            for (var k = 0; k < reveals.length; k++) {
              reveals[k].classList.add('is-visible');
            }
          });
        });
      }
    }

    for (var i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', function (e) {
        activateTab(e.currentTarget);
      });
    }

    // Keyboard navigation: arrow keys between tabs
    for (var j = 0; j < tabs.length; j++) {
      tabs[j].addEventListener('keydown', function (e) {
        var currentIndex = -1;
        for (var k = 0; k < tabs.length; k++) {
          if (tabs[k] === e.currentTarget) {
            currentIndex = k;
            break;
          }
        }

        var nextIndex = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          nextIndex = (currentIndex + 1) % tabs.length;
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        }

        if (nextIndex >= 0) {
          tabs[nextIndex].focus();
          activateTab(tabs[nextIndex]);
        }
      });
    }

    // Initial reveal for active panel
    var activePanel = section.querySelector('.oddit-section-product-recommendations__panel--active');
    if (activePanel) {
      var reveals = activePanel.querySelectorAll('.oddit-reveal');
      requestAnimationFrame(function () {
        for (var m = 0; m < reveals.length; m++) {
          reveals[m].classList.add('is-visible');
        }
      });
    }
  }

  // Init all instances
  var sections = document.querySelectorAll(SECTION_SELECTOR);
  for (var i = 0; i < sections.length; i++) {
    initSection(sections[i]);
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();